import { Select } from '@leagueplatform/genesis-core';
import { capitalizeString } from '../../utils/convertString';
import { useFiltering } from '../../utils/useFiltering';

export function FilterSelect({
  data,
  label,
  id,
}: {
  label: string;
  data: string[];
  id: string;
}) {
  const { setFilters, filters } = useFiltering();

  const options = data.map((item: string) => ({
    id: item,
    label: capitalizeString(item),
    value: item,
  }));

  return (
    <Select
      data-testid={id}
      value={filters[id]}
      onChange={(e) => setFilters({ ...filters, [id]: e.currentTarget.value })}
      id={label}
      options={[
        {
          key: '',
          label: label,
          value: '',
        },
        ...options,
      ]}
    />
  );
}
